import {
  WebSocketMessage,
  WebSocketLockData,
  WebSocketUnlockData,
  WebSocketSubscribeData,
} from '../types/websocket';

class WebSocketClient {
  private ws: WebSocket;
  private sessionId: string;
  private onUpdateCallback?: (data: WebSocketMessage) => void;

  constructor(sessionId: string, onUpdate?: (data: WebSocketMessage) => void) {
    this.sessionId = sessionId;
    this.onUpdateCallback = onUpdate;

    const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const host = process.env.REACT_APP_BACKEND_HOST;
    const wsUrl = `${wsProtocol}//${host}`;

    console.log('Attempting WebSocket connection to:', wsUrl);
    this.ws = new WebSocket(wsUrl);
    this.initialize();
  }

  private initialize() {
    this.ws.onopen = () => {
      console.log('WebSocket connection established');
      const subscribeMessage: WebSocketSubscribeData = {
        type: 'subscribe',
        data: {
          sessionId: this.sessionId,
        },
      };
      this.ws.send(JSON.stringify(subscribeMessage));
    };

    this.ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data) as WebSocketMessage;
        this.onUpdateCallback?.(data);
      } catch (error) {
        console.error('WebSocket message error:', error);
      }
    };

    this.ws.onclose = (event) => {
      console.log('WebSocket connection closed:', event.code, event.reason);
    };

    this.ws.onerror = (error) => {
      console.error('WebSocket error:', error);
    };
  }

  public lockNode(nodeId: string, userId: string, username: string) {
    if (this.ws.readyState === WebSocket.OPEN) {
      const message: WebSocketLockData = {
        type: 'LOCK',
        data: {
          sessionId: this.sessionId,
          nodeId,
          userId,
          username,
        },
      };
      this.ws.send(JSON.stringify(message));
    }
  }

  public unlockNode(nodeId: string, userId: string, username: string) {
    if (this.ws.readyState === WebSocket.OPEN) {
      const message: WebSocketUnlockData = {
        type: 'UNLOCK',
        data: {
          sessionId: this.sessionId,
          nodeId,
          userId,
          username,
        },
      };
      this.ws.send(JSON.stringify(message));
    }
  }

  public close() {
    this.ws.close();
  }
}

export default WebSocketClient;
